module.exports = __webpack_public_path__ + "static/week_columns_2_weeks-cc1012ad46020a0ef6a19bb5f23354ab.png";